module.exports = __webpack_public_path__ + "img/n4.07f023cb.png";